import tagTester from './_tagTester.js';

export default tagTester('String');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isString.js
// module id = 377
// module chunks = 1